import theme_icons from '../../icons.js';

const { useSelect } = wp.data;
const { decodeEntities } = wp.htmlEntities;
const { useState } = wp.element;
const { __ } = wp.i18n;
const { registerBlockType } = wp.blocks;
const { RichText, InspectorControls, MediaUploadCheck, MediaUpload } = wp.blockEditor;
const { SearchControl, PanelBody, Spinner, Button, ToggleControl, SelectControl, TextControl, ColorPicker } = wp.components;

const featuredposts = {
    title: 'Featured Posts',
    icon: theme_icons.greenheart,
    category: 'greenheart',
    supports: {
        //align: ['alignwide', 'aligncenter', 'alignfull', 'alignleft', 'alignright']
        align: true
    },
    //attributes
    attributes: {
        title: {
            type: 'string',
            default: ''
        },
        hlevel: {
            type: 'string',
            default: null,
        },
        text: {
            type: 'string',
            default: ''
        },
        textcenter: {
            type: 'boolean',
            default: false
        },
        image: {
            type: 'object',
            default: {}
        },
        /* Default stuff */
        reversed: {
            type: 'boolean',
            default: false,
        },
        variant: {
            type: 'string',
            default: null
        },
        showExcerpt: {
            type: 'boolean',
            default: false
        },

        /* Selected Data */
        selectedPosts: {
            type: 'array',
            default: []
        },
        /* Background */
        bgType: {
            type: 'string',
            default: 'None'
        },
        isLinearGradient: {
            type: 'boolean',
            default: true,
        },
        gradientArg: {
            type: 'string',
            default: 'to left'
        },
        bgColor: {
            type: 'string',
            default: null
        },
        bgColorTwo: {
            type: 'string',
            default: null
        },
        expandAdder: {
            type: 'boolean',
            default: false
        }
    },

    edit({ attributes, setAttributes }) {
        const { title, hlevel, text, textcenter, image, reversed, variant, selectedPosts, showExcerpt, bgType, bgColor, bgColorTwo, expandAdder, isLinearGradient, gradientArg } = attributes;
        function onTextChange(newtext) {
            setAttributes({ text: newtext });
        }
        function onTitleChange(newtitle) {
            setAttributes({ title: newtitle });
        }
        function setColorOne(newcolor) {
            setAttributes({ bgColor: newcolor });
        }
        function setColorTwo(newcolor) {
            setAttributes({ bgColorTwo: newcolor });
        }
        function onSelectMedia(media) {
            setAttributes({ image: media });
        }

        function RemovePostButtonClick(post_id) {
            const updatedPosts = selectedPosts.filter(pst => { return pst.id !== post_id });
            setAttributes({ selectedPosts: updatedPosts, expandAdder: false });
        }
        function AddPostButtonClick(pageobject) {
            if (typeof pageobject.id === "undefined") {
                console.log("Could not add post - problem with pageobject passed to function.");
                return false;
            }
            wp.apiFetch({
                path: 'gbe/v1/featuredposts/' + pageobject.id,
            }).then(data => {
                console.log("DATA", data);
                if (data.code !== 200) {
                    setAttributes({
                        selectedPosts: [...selectedPosts,
                        {
                            id: pageobject.id,
                            title: decodeEntities(pageobject.title.rendered),
                            excerpt: decodeEntities(pageobject.excerpt.rendered),
                            slug: pageobject.slug,
                            link: pageobject.link,
                            featuredImage: "",
                            featuredImageSrcSet: "",
                            authorName: "",
                            authorLink: "",
                            primaryCategory: "",
                            categories: ""
                        }],

                        expandAdder: !expandAdder
                    });
                    return false;
                } else {
                    setAttributes({
                        selectedPosts: [...selectedPosts,
                        {
                            id: pageobject.id,
                            title: decodeEntities(pageobject.title.rendered),
                            excerpt: decodeEntities(pageobject.excerpt.rendered),
                            slug: pageobject.slug,
                            link: pageobject.link,
                            featuredImage: data.payload.thumbnail_url,
                            featuredImageSrcSet: data.payload.thumbnail_src_set,
                            authorName: data.payload.author_name,
                            authorLink: data.payload.author_link,
                            primaryCategory: data.payload.primary_category,
                            categories: data.payload.categories
                        }],

                        expandAdder: !expandAdder
                    });
                    return false;
                }


            });
        }
        function SelectPage() {
            const [searchTerm, setSearchTerm] = useState('');
            const { pages, hasResolved } = useSelect(
                select => {
                    const query = {};
                    if (searchTerm) {
                        query.search = searchTerm;
                        query._embed = true;
                    }
                    return {
                        pages: select('core').getEntityRecords('postType', 'post', query),
                        hasResolved: select('core').hasFinishedResolution('getEntityRecords', ['postType', 'post', query]),
                    }

                }, [searchTerm]);
            return (
                <div>
                    <SearchControl
                        onChange={setSearchTerm}
                        value={searchTerm}
                    />
                    <PagesList hasResolved={hasResolved} pages={pages} />
                </div>
            );

        }
        function truncateExcerpt(excerpt, wordLimit = 24) {
            const words = excerpt.split(' ');
            if (words.length > wordLimit) {
                return words.slice(0, wordLimit).join(' ') + '...';
            }
            return excerpt;
        }
        function stripTheTags(htmlstring) {
            //return htmlstring.replace(/(<([^>]+)>)/ig,"");
            var temp = document.createElement("div");
            temp.innerHTML = htmlstring;
            let text = temp.textContent || temp.innerText || "";
            text = truncateExcerpt(text);
            return (<div className="stripped-excerpt">{text}</div>);
        }
        function PagesList({ hasResolved, pages }) {
            if (!hasResolved) {
                return <Spinner />
            }
            if (!pages?.length) {
                return <div>No results</div>
            }
            const selectedIds = selectedPosts.map(item => { return item.id })
            return (
                <table className="wp-list-table widefat fixed striped table-view-list">
                    <thead>
                        <tr>
                            <th>Post Title</th><th>Feature</th>
                        </tr>
                    </thead>
                    <tbody>
                        {pages?.map(page => {
                            { console.log("Page", page) }
                            if (!selectedIds.includes(page.id)) {
                                return (
                                    <tr key={page.id}>
                                        <td>{decodeEntities(page.title.rendered)}</td>
                                        <td>
                                            {selectedPosts.length < 4 &&
                                                <Button variant="primary" onClick={() => {
                                                    AddPostButtonClick(page)
                                                }}>

                                                    Add
                                                </Button>
                                            }
                                        </td>
                                    </tr>
                                )
                            }
                        }
                        )}
                    </tbody>
                </table>
            )
        }
        function postCard(selectedPosts) {
            console.log(selectedPosts);
            return (
                <div className="featured-posts">
                    {
                        selectedPosts.map(pst => (

                            <div className={"post-card " + variant ?? "card"}>
                                <div className="post-img-wrap">
                                    {pst.featuredImage &&
                                        <a href={pst.link}>
                                            <img width="400" className="post-img-tag" src={pst.featuredImage} alt={pst.title} loading="lazy" srcset={pst.featuredImageSrcSet} />
                                        </a>
                                    }
                                </div>
                                <div className={"post-details " + variant ?? "card"}>
                                    <a href={pst.link}><h3 className="post-title">{pst.title}</h3></a>
                                    {showExcerpt ? <div className="post-excerpt">{stripTheTags(pst.excerpt)}</div> : null}

                                    <div className="post-meta">
                                        <span className="post-author">{pst.authorName ?? ''}</span> in <a href={pst.primaryCategory.link ?? '/category/' + pst.primaryCategory.slug}><span className="post-category">{pst.primaryCategory.name ?? ''}</span></a>
                                    </div>

                                    <Button variant="secondary" className="rbt-editor-remove" style={{ float: "right", width: "fit-content" }} onClick={() => { RemovePostButtonClick(pst.id); }} >Remove Post</Button>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )
        }
        function RenderBackgroundDetails({ type }) {
            switch (type) {
                case "Image": return (
                    <MediaUploadCheck>
                        <p><strong>Upload Image:</strong></p>
                        <MediaUpload
                            label="Image"
                            onSelect={(media) => { onSelectMedia(media) }}
                            allowedTypes={['image']}
                            accept={["image/*", "image/svg"]}
                            value={image.id}

                            render={({ open }) => {
                                return (
                                    <>
                                        <Button
                                            isPrimary={true}
                                            onClick={(event) => {
                                                event.stopPropagation();
                                                open();
                                            }}
                                        >
                                            {image.id > 0 ? 'Edit Image' : 'Upload Image'}
                                        </Button>
                                    </>
                                );
                            }}
                        />
                    </MediaUploadCheck>
                ); break;
                case "Color": return (
                    <>
                        <p><strong>Background Color:</strong></p>
                        <ColorPicker
                            color={bgColor}
                            onChange={(color) => setColorOne(color)}
                            enableAlpha
                        />
                    </>
                ); break;
                case "Gradient": return (
                    <>
                        <p><strong>Gradient Start Color:</strong></p>
                        <ColorPicker
                            color={bgColor}
                            onChange={(color) => setColorOne(color)}
                            enableAlpha
                        />
                        <p><strong>Gradient End Color:</strong></p>
                        <ColorPicker
                            color={bgColorTwo}
                            onChange={(color) => setColorTwo(color)}
                            enableAlpha
                        />
                        <p><strong>Gradient Style</strong></p>
                        <ToggleControl
                            help={isLinearGradient ? 'Linear' : 'Radial'}
                            checked={isLinearGradient}
                            onChange={() => { setAttributes({ isLinearGradient: !isLinearGradient }); }}
                        />
                        {isLinearGradient ?
                            <TextControl
                                label="(optional) First Linear Gradient Argument (Ex: 'to top, 45deg, etc.')"
                                placeholder="to left"
                                value={gradientArg}
                                onChange={(text) => { setAttributes({ gradientArg: text }) }}
                            /> : null}
                    </>
                ); break;
            }
        }
        function maybeEllipses(str) {
            if (str.slice(-1) !== '.') {
                return str + '...';
            }
            return str;
        }
        function renderStyle() {
            switch (bgType) {
                case "None": return null; break;
                case "Image": return ({ backgroundImage: 'url(' + image.url + ')' }); break;
                case "Color": return ({ backgroundColor: bgColor }); break;
                case "Gradient":
                    if (isLinearGradient) {
                        const argOne = gradientArg ? gradientArg : 'to left';
                        return ({ backgroundImage: 'linear-gradient(' + argOne + ', ' + bgColor + ', ' + bgColorTwo + ')' })
                    } else {
                        const argOne = gradientArg ? gradientArg : 'to left';
                        return ({ backgroundImage: 'radial-gradient(' + bgColor + ', ' + bgColorTwo + ')' })
                    }
                    break;
            }
        }
        return ([
            <InspectorControls style={{ marginBottom: '20px' }}>
                <PanelBody title="Layout">
                    <p><strong>Switch Direction?</strong></p>
                    <ToggleControl
                        label="Switch Direction?"
                        help={reversed ? 'Text Left' : 'Text Right'}
                        checked={reversed}
                        onChange={() => setAttributes({ reversed: !reversed })}
                    />
                    <p><strong>Layout</strong></p>
                    <SelectControl
                        label="Block Style"
                        value={variant}
                        onChange={(selected) => { setAttributes({ variant: selected }) }}
                        options={[
                            { label: 'Default', value: null },
                            { label: 'Compact', value: 'compact' },
                            { label: 'Cards', value: 'card' },
                            { label: 'Index', value: 'index' }
                        ]}
                    />
                    <p><strong>Heading Level</strong></p>
                    <SelectControl
                        label="Heading Level"
                        value={hlevel}
                        onChange={(selected) => { setAttributes({ hlevel: selected }) }}
                        options={[
                            { label: 'H1', value: 'h1' },
                            { label: 'H2', value: 'h2' },
                            { label: 'H3', value: 'h3' },
                            { label: 'H4', value: 'h4' },
                            { label: 'H5', value: 'h5' },
                            { label: 'H6', value: 'h6' }
                        ]}
                    />
                    <p><strong>Text Centered?</strong></p>
                    <ToggleControl
                        label="Center the Heading and Subheading Text?"
                        help={textcenter ? 'Centered' : 'Left Aligned'}
                        checked={textcenter}
                        onChange={() => setAttributes({ textcenter: !textcenter })}
                    />
                    <p><strong>Show Excerpt?</strong></p>
                    <ToggleControl
                        label="Excerpt?"
                        help={showExcerpt ? 'Show' : 'Hide'}
                        checked={showExcerpt}
                        onChange={() => setAttributes({ showExcerpt: !showExcerpt })}
                    />

                </PanelBody>
                <PanelBody title="Background">
                    <p><strong>Background Settings:</strong></p>
                    <SelectControl
                        label="Background Type"
                        value={bgType}
                        onChange={(selected) => { setAttributes({ bgType: selected }) }}
                        options={[
                            { label: 'None', value: 'None' },
                            { label: 'Image', value: "Image" },
                            { label: 'Color', value: 'Color' },
                            { label: 'Gradient', value: 'Gradient' },
                        ]}
                    />
                    {bgType === 'None' ? '' : <p><strong>Details</strong></p>}
                    {bgType === 'None' ? '' : <RenderBackgroundDetails type={bgType} />}

                </PanelBody>
            </InspectorControls>,
            <div className={`rbt-featured-posts ${variant}`} >
                {<div className="underlay" style={renderStyle()}></div>}
                <div className="filters"></div>
                <div className={reversed ? "layout reversed" : "layout"}>
                    <div className="block-one">
                        <RichText
                            tagName="h2"
                            className="modtitle"
                            value={title}
                            onChange={onTitleChange}
                            placeholder={'Section Title'}
                        />
                        <RichText
                            tagName="div"
                            className="rbt-accordion-panel"
                            value={text}
                            onChange={onTextChange}
                            placeholder={'Lorem ipsum dolor sit amet, consectetur adipiscing elit.'}
                        />
                    </div>
                    <div className="block-two">
                        {selectedPosts && selectedPosts.length ? postCard(selectedPosts) : null}
                        {selectedPosts.length < 4 ?
                            (expandAdder ? SelectPage() : <Button variant="primary" onClick={() => { setAttributes({ expandAdder: !expandAdder }) }}>Add Featured Post</Button>) : null
                        }
                    </div>

                </div>
            </div>

        ]);
    },
    save({ attributes }) {
        const { title, hlevel, text, textcenter, image, reversed, variant, selectedPosts, bgType, bgColor, bgColorTwo, showExcerpt, isLinearGradient, gradientArg } = attributes;
        const textCenterSubtitle = textcenter ? "text-center" : "";
        const v = variant ? variant : "card";
        function maybeEllipses(str) {
            if (str.slice(-1) !== '.') {
                return str + '...';
            }
            return str;
        }
        function renderHeader(header) {
            const classname = textcenter ? "text-center" : "";
            switch (hlevel) {
                case 'h1': return <h1 className={classname}>{header}</h1>; break;
                case 'h2': return <h2 className={classname}>{header}</h2>; break;
                case 'h3': return <h3 className={classname}>{header}</h3>; break;
                case 'h4': return <h4 className={classname}>{header}</h4>; break;
                case 'h5': return <h5 className={classname}>{header}</h5>; break;
                case 'h6': return <h6 className={classname}>{header}</h6>; break;
                default: return <h3 className={classname}>{header}</h3>; break;
            }
        }
        function truncateExcerpt(excerpt, wordLimit = 24) {
            const words = excerpt.split(' ');
            if (words.length > wordLimit) {
                return words.slice(0, wordLimit).join(' ') + '...';
            }
            return excerpt;
        }
        function postCard(selectedPosts) {

            return (
                <div className="featured-posts">
                    {
                        selectedPosts.map(pst => (

                            <div className={"post-card " + variant ?? "card"}>
                                <div className="post-img-wrap">
                                    {(pst.featuredImage !== 0) &&
                                        <a href={pst.link}>
                                            <img width="400" className="post-img-tag" src={pst.featuredImage} alt={pst.title} loading="lazy" srcset={pst.featuredImageSrcSet} />
                                        </a>
                                    }
                                </div>
                                <div className={"post-details " + variant ?? "card"}>
                                    <a className="a-charcoal" href={pst.link}><h5 className="post-title">{pst.title}</h5></a>
                                    <div className={showExcerpt ? "post-excerpt" : "post-excerpt hidden"}>{stripTheTags(pst.excerpt)}</div>
                                    <div className="post-meta">
                                        <span className="post-author"> - {pst.authorName}</span> in <a href={pst.primaryCategory.link ? pst.primaryCategory.link : '/category/' + pst.primaryCategory.slug}><span className="post-category">{pst.primaryCategory.name ?? ''}</span></a>
                                    </div>
                                </div>
                            </div>
                        ))
                    }
                </div>
            )
        }
        function renderStyle() {
            switch (bgType) {
                case "None": return null; break;
                case "Image": return ({ backgroundImage: 'url(' + image.url + ')' }); break;
                case "Color": return ({ backgroundColor: bgColor }); break;
                case "Gradient":
                    if (isLinearGradient) {
                        const argOne = gradientArg ? gradientArg : 'to left';
                        return ({ backgroundImage: 'linear-gradient(' + argOne + ', ' + bgColor + ', ' + bgColorTwo + ')' })
                    } else {
                        const argOne = gradientArg ? gradientArg : 'to left';
                        return ({ backgroundImage: 'radial-gradient(' + bgColor + ', ' + bgColorTwo + ')' })
                    }
                    break;
            }
        }
        function stripTheTags(htmlstring) {
            //return htmlstring.replace(/(<([^>]+)>)/ig,"");
            var temp = document.createElement("div");
            temp.innerHTML = htmlstring;
            let text = temp.textContent || temp.innerText || "";
            text = truncateExcerpt(text);
            return (<div className="stripped-excerpt">{text}</div>);
        }
        return (
            <div className={`rbt-featured-posts ${v}`} >
                <div className="underlay"
                    style={renderStyle()}
                ></div>
                <div className="filters"></div>
                <div className={reversed ? "layout reversed" : "layout"}>
                    <div className="block-one">
                        {title.length ? renderHeader(title) : null}
                        {text.length ?
                            <div className="rbt-featured-posts-text">
                                <RichText.Content
                                    tagName="p"
                                    className={textCenterSubtitle}
                                    value={text}
                                />
                            </div>
                            : null}
                    </div>
                    <div className="block-two">
                        <div className="rbt-featured-posts-list">
                            {postCard(selectedPosts)}
                        </div>
                    </div>
                </div>
            </div>
        )
    }
};
registerBlockType('rbt/featuredposts', featuredposts);
export default featuredposts;